<div *ngIf="listData!=undefined">
    <div class="grid-table">
        <div class="table-container shadow">
            <div class="table-manage">
                <div class="row">
                    <div class="col">
                        <div class="manage-item records-count">
                            <span>{{listData.Items.length}} {{'HOME.MAINMENU_NAVIGATION_RULES' | translate}}</span>
                        </div>
                    </div>
                    <div class="col">
                       
                        <div class="manage-item number-of-pages float-end">
                            <label>{{'GLOBAL.LIST_PAGESIZE_SHOW' | translate}}:</label>
                            <div class="select-items">
                                <select name="pageSize" [(ngModel)]="pageSize" (change)="loadData()">
                                    <option _ngcontent-gts-c7="" value="5" ng-reflect-value="5">5 {{'GLOBAL.LIST_RECORDS_PER_PAGE' | translate}}</option>
                                    <option _ngcontent-gts-c7="" value="10" ng-reflect-value="10">10 {{'GLOBAL.LIST_RECORDS_PER_PAGE' | translate}}</option>
                                    <option _ngcontent-gts-c7="" value="25" ng-reflect-value="25">25 {{'GLOBAL.LIST_RECORDS_PER_PAGE' | translate}}</option>
                                    <option _ngcontent-gts-c7="" value="50" ng-reflect-value="50">50 {{'GLOBAL.LIST_RECORDS_PER_PAGE' | translate}}</option>
                                    <option _ngcontent-gts-c7="" value="100" ng-reflect-value="100">100 {{'GLOBAL.LIST_RECORDS_PER_PAGE' | translate}}</option>
                                </select>
                            </div>
                        </div>
                        <div class="manage-item float-end search-input">
                            <input style="width: 200px;" name="queryString" [(ngModel)]="queryString" />
                            <button (click)="loadData()">{{'GLOBAL.SEARCH_BUTTON_TEXT' | translate}}</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="table-wrapper">
                <table class="table table-striped">
                    <thead>
                        <tr>
                            <th>ID</th>
                            <th>{{'NAVIGATION_NODE_RULE.CONDITION' | translate}}</th>
                            <th>{{'NAVIGATION_NODE_RULE.TYPE' | translate}}</th>
                            <th>{{'NAVIGATION_NODE_RULE.ACTIONBODY' | translate}}</th>
                            <th>{{'NAVIGATION_NODE_RULE.USER' | translate}}</th>
                            <th>{{'NAVIGATION_NODE_RULE.USERGROUP' | translate}}</th>
                            <th>{{'NAVIGATION_NODE_RULE.FORMACTION' | translate}}</th>
                            <th class="actions"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of listData.Items">
                            <td>{{item.Id}}</td>
                            <td>{{item.Condition}}</td>
                            <td>{{item.RuleType}}</td>
                            <td>{{item.ActionBody}}</td>
                            <td>{{item.User?.Id}}</td>
                            <td>{{item.UserGroup?.Id}}</td>
                            <td>{{item.FormAction?.Id}}</td>
                            <td>
                                <div class="controls">
                                    <div class="edit"><a routerLink="/navigation/rules/edit/{{item.Id}}"></a></div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>